export interface StaffMember {
  id: string;
  name: string;
  avatar?: string;
  color: string;
  role?: string;
  initials: string;
}

// Super Admin user - shown only when superadmin PIN is used
export const SUPERADMIN_STAFF: StaffMember = {
  id: 'staff_superadmin',
  name: 'Rubén',
  color: '#5D4037',
  initials: 'RR',
  role: 'Gerente'
};

export const STAFF_MEMBERS: StaffMember[] = [
  {
    id: 'staff_001',
    name: 'María García',
    color: '#FF6B6B',
    initials: 'MG',
    role: 'Encargada'
  },
  {
    id: 'staff_002',
    name: 'Carlos Rodríguez',
    color: '#4ECDC4',
    initials: 'CR',
    role: 'Dependiente'
  },
  {
    id: 'staff_003',
    name: 'Ana Martínez',
    color: '#FFE66D',
    initials: 'AM',
    role: 'Dependiente'
  },
  {
    id: 'staff_004',
    name: 'Pedro López',
    color: '#95E1D3',
    initials: 'PL',
    role: 'Repostero'
  },
  {
    id: 'staff_005',
    name: 'Laura Sánchez',
    color: '#F38181',
    initials: 'LS',
    role: 'Dependiente'
  },
  {
    id: 'staff_006',
    name: 'David Fernández',
    color: '#AA96DA',
    initials: 'DF',
    role: 'Auxiliar'
  }
];

export const getStaffMemberById = (id: string): StaffMember | undefined => {
  return STAFF_MEMBERS.find(member => member.id === id);
};

export const getStaffMemberByName = (name: string): StaffMember | undefined => {
  return STAFF_MEMBERS.find(member => 
    member.name.toLowerCase() === name.toLowerCase()
  );
};
